<template>
  <div>
    <button-options
      :access="access"
      :hideAdd="true"
      :hideDelete="false"
      :hideDetail="false"
      :hideEdit="true"
      :viewTo="viewTo"
      @onDeleteClicked="onDeleteClicked"/>
  </div>
</template>

<script>

import ButtonOptions from '../../directives/button-options';

export default {
  name: 'RoleEdit',
  components: { ButtonOptions },
  props: ['access', 'role', 'viewTo'],
  computed: {
    data() {
      return { ...this.role };
    },
  },
  methods: {
    onDeleteClicked() {
      this.$emit('onDeleteClicked', this.data);
    },
  },
};
</script>

<style scoped>

</style>
